{
  "loan-disclosures": "Divulgaciones de Préstamos",
  "assumption": "Suposición",
  "assumption-subtitle": "Si vende o transfiere esta propiedad a otra persona, su prestamista",
  "assumption-option-1": "permitirá la suposición",
  "assumption-option-2": "no permitirá la suposición",
  "demand-feature": "Característica de Demanda",
  "demand-feature-subtitle": "Tu préstamo",
  "demand-feature-option-1": "tiene una función de demanda",
  "demand-feature-option-2": "sin función de demanda",
  "negative-amortization": "Amortización Negativa",
  "negative-amortization-subtitle": "Según los términos del préstamo, usted",
  "negative-amortization-option-1": "tener una amortización negativa como característica",
  "negative-amortization-option-2": "puede tener una amortización negativa",
  "negative-amortization-option-3": "no es una característica del préstamo",
  "partial-payments": "Pagos Parciales",
  "partial-payments-subtitle": "Su prestamista",
  "partial-payments-option-1": "puede aceptar pagos parciales",
  "partial-payments-option-2": "puede mantenerlas en una cuenta separada",
  "partial-payments-option-3": "no acepta pagos parciales",
  "escrow-account": "Cuenta de Fideicomiso",
  "escrow-account-subtitle": "Por ahora, tu préstamo",
  "escrow-account-option-1": "tiene fideicomiso",
  "escrow-account-option-2": "no tendrá fideicomiso",
  "escrow-account-subtitle-will-not": "Porque",
  "escrow-account-option-1-will-not": "el depósito en garantía ha disminuido",
  "escrow-account-option-2-will-not": "el prestamista no ofrece fideicomiso"
}
